var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0 0.324)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 20,
    height: 20,
    transform: "translate(0 -0.324)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(4.317 0.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1730.26,2597.423l.446.06a3.14,3.14,0,0,1,2.757,2.624,3.1,3.1,0,0,1-.684,2.643,2.874,2.874,0,0,1-1.736.951,3.566,3.566,0,0,1-2.6-.545,2.851,2.851,0,0,1-1.344-2.044,3.178,3.178,0,0,1,1.746-3.387,3.093,3.093,0,0,1,1.121-.269,1.107,1.107,0,0,0,.17-.033Z",
    transform: "translate(-1724.55 -2597.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    d: "M5.738,0h0a5.738,5.738,0,0,1,5.738,5.738V8.019a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.738A5.738,5.738,0,0,1,5.738,0Z",
    transform: "translate(0 7.377)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAccount);
export default __webpack_public_path__ + "static/media/white_account.9ea9e6b00d456cf3d604da8810a03ecc.svg";
export { ForwardRef as ReactComponent };